import { render, staticRenderFns } from "./babyMameDesSet.vue?vue&type=template&id=474f5a19&scoped=true&"
import script from "./babyMameDesSet.vue?vue&type=script&lang=js&"
export * from "./babyMameDesSet.vue?vue&type=script&lang=js&"
import style0 from "./babyMameDesSet.vue?vue&type=style&index=0&id=474f5a19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f5a19",
  null
  
)

export default component.exports